import { Injectable } from '@angular/core';
import { BaseHubService } from './base-hub.service';
import { HttpClient } from '@angular/common/http';
import { MessageService } from '../local/message.service';
import { ConfigService } from '../local/config.service';
import { Store } from '@ngrx/store';
import { MainStoreState } from '../../_store/mainStoreState';
import { BehaviorSubject } from 'rxjs';
import { HubConnectionState } from '@microsoft/signalr';

@Injectable({
  providedIn: 'root',
})
export class KafkaHealthService extends BaseHubService<any> {
  constructor(
    http: HttpClient,
    messageService: MessageService,
    configService: ConfigService,
    private store: Store<MainStoreState>
  ) {
    super(
      '',
      'hubs/kafkaHealthHub',
      'Kafka Health',
      http,
      messageService,
      configService
    );
  }

  active$ = new BehaviorSubject<string>(HubConnectionState.Disconnected);

  refreshHubConnection(): Promise<void> {
    return this.start();
  }

  protected dispatchUpdateData(data: any): void {
    this.active$.next(
      data ? HubConnectionState.Connected : HubConnectionState.Disconnected
    );
  }
}
